import React from 'react';
import Modal from 'react-bootstrap/Modal';

const InputText = React.memo(props => {
  return (
    <input
      autoFocus
      type="text"
      name={props.name}
      className="optBox"
      id={props.id}
      size={props.size}
      placeholder={props.placeholder}
      onChange={props.onChange}
      value={props.value}
      onClick={props.onClick}
    />
  )
})

const LabelNameChangeModal = (props) => {
  // handleNameChangeShow={handleNameChangeShow}
  // handleNameChangeClose={handleNameChangeClose}
//  handleChangeLabelNameInput={props.handleChangeLabelNameInput} handleNameChangeShow={props.handleNameChangeShow} handleNameChangeClose={props.handleNameChangeClose} nameChangeShow={props.nameChangeShow}

  const handleSaveBtn = () => {
    props.handleChangeLabelName(props.changeLabelName);
    props.handleNameChangeClose();
  }

  const handleCancleBtn = () => {
    props.handleNameChangeClose();
  }

  return (
    <Modal show={props.nameChangeShow} onHide={props.handleNameChangeClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {`[${props.selectedLabelName}] 그룹 명 수정`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <InputText placeholder="새로운 그룹 명을 입력하세요"
          onChange={props.handleChangeLabelNameInput} value={props.changeLabelName} name="textfield" type="text" className="box" id="textfield" size="35" 
         />
      </Modal.Body>
      <Modal.Footer style={{display:"block",float:"left", textAlign:"right"}}>
        <a className="button purple" onClick={handleSaveBtn}>저장</a>
        <a className="button purple" onClick={handleCancleBtn}>취소</a>
      </Modal.Footer>
    </Modal>

  )
}

export default React.memo(LabelNameChangeModal);